import config from "next/config";

const { publicRuntimeConfig } = config();

export const generateSHA256Checksum = async (file: File) => {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const CONTENT_HUB_IMAGE_FALLBACK_URL =
  "https://usercontent.events.ringcentral.com/default_images/event-default-picture-1500x600.jpg";

export const getAssetUrl = (
  path: string,
  fallbackImageUrl: string = CONTENT_HUB_IMAGE_FALLBACK_URL
) => {
  if (!path) return fallbackImageUrl;
  return `${publicRuntimeConfig.CONTENT_MEDIA_CDN}${path}`;
};

export const getPageUrl = (
  organizationExternalId: string,
  pageSlug: string
) => {
  return `${publicRuntimeConfig.CONTENT_PAGES_CDN}/${organizationExternalId}/pages/${pageSlug}.json`;
};
